import {Button} from './apply-filter-button.styled'

import {useToggle} from '../../../../../contexts/toggle/use-toggle'

export function FilterButton(): JSX.Element {
    const {setValue: setShowFilter} = useToggle()

    return <Button onClick={() => setShowFilter(false)}>Filter</Button>
}
